import { axios, getConfigs } from './common';

export default class NotificationTypeService {
  async getList(params) {
    return new Promise(async (resolve, reject) => {
      let url = `/types`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }
}